// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2naYi","title":"ClientInsurance_title__2m2fE","itemText":"ClientInsurance_itemText__2duTI"};